import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import configureStore, { history } from "store/configureStore";
import "styles/app.scss";
import Router from "./Router";
import { QueryClientProvider, QueryClient } from "react-query";
import {
  QueryClientProvider as TanstackQueryClientProvider,
  QueryClient as TanstackQueryClient,
} from "@tanstack/react-query";
import { FeatureFlags } from "analytics-ui/FeatureFlags";

const initialState = window.REDUX_INITIAL_STATE || {};
// TODO: remove export, need to rewrite actions
export const store = configureStore(initialState);
const queryClient = new QueryClient();
const tanstackQueryClient = new TanstackQueryClient();

function App() {
  return (
    <Provider store={store}>
      <TanstackQueryClientProvider client={tanstackQueryClient}>
        <QueryClientProvider client={queryClient}>
          <ConnectedRouter history={history}>
            <FeatureFlags>
              <Router />
            </FeatureFlags>
          </ConnectedRouter>
        </QueryClientProvider>
      </TanstackQueryClientProvider>
    </Provider>
  );
}

App.propTypes = {
  store: PropTypes.object,
};

export default App;
